import asyncify from '../../../../commons/utils/asyncify';
import {
    animateInICSLink,
} from '../../animations/animate';

async function gotoWithTransition (gotoFunc) {
    const astore = this.env.animationsStore;
    await astore.animatePageTransition(gotoFunc);
}

function gotoIndex () {
    asyncify(() => {
        this.goto('/');
    }, {}, 200);
}

function gotoLoading () {
    this.goto('/loading');
}

function gotoErrors () {
    this.goto('/errors');
}

function gotoCalendarApps () {
    this.gotoWithTransition(() => {
        this.goto('/calendars');
    });
}

function gotoSchedules () {
    this.gotoWithTransition(() => {
        this.goto('/schedules');
    });
}

function gotoInAppGuide() {
    this.gotoWithTransition(() => {
        this.goto('/inAppGuide');
    });
}

function gotoSuccessInfo () {
    this.gotoWithTransition(() => {
        this.gaSubscribeComplete();
        this.goto('/success');
    });
}

function gotoSuccessInfoNoTransition () {
    console.log('');
    console.log('');
    console.log('');
    console.log('gotoSuccessInfoNoTransition() ....');
    this.goto('/success');
}

function gotoSubscriberForm () {
    this.gotoWithTransition(() => {
        this.goto('/subscriber');
    });
}

function gotoICSLink () {
    this.gotoWithTransition(() => {
        this.goto('/icslink');
    });
}

/* Implemented for New Outlook to Copy ICS */

function gotoICSLinkOutlook () {
    this.gotoWithTransition(() => {
        this.goto('/outlook-new');
    });
}

function gotoOauthLauncher () {
    if (this.page.indexOf('/oauthlauncher') !== -1) {
        return;
    }
    this.gotoWithTransition(() => {
        this.goto('/oauthlauncher');
    });
}

function gotoOutlookNewGuide () {
    this.goto('/outlook-new-guide');
}

function gotoOauthLoading () {
    this.gotoWithTransition(() => {
        this.goto('/oauthloading');
    });
}

function gotoOauthFailed () {
    this.gotoWithTransition(() => {
        this.goto('/oauthfail');
    });
}

function gotoHavingTrouble () {
    this.gotoWithTransition(() => {
        this.goto('/havingtrouble');
    });
}

function gotoAlmostDone () {
    this.gotoWithTransition(() => {
        this.gaAlmostDoneProc();
        this.goto('/almostdone');
    });
}

function tryAgain ({ selectedCalendar }) {
    console.log('tryAgain() -> ', selectedCalendar);
    if (selectedCalendar === 'ics_other') {
        animateInICSLink(this.env);
        return;
    } 

    if (typeof this.syncAction === 'function') {
        this.syncAction();
        return;
    }
}

const gotoRoutes = {
    gotoLoading,
    gotoCalendarApps,
    gotoSchedules,
    gotoSuccessInfo,
    gotoSubscriberForm,
    gotoOauthLoading,
    gotoOauthFailed,
    gotoInAppGuide,
    gotoICSLink,
    gotoHavingTrouble,
    gotoAlmostDone,
    tryAgain,
    gotoICSLinkOutlook,
    gotoOutlookNewGuide,
    gotoOauthLauncher,
    gotoWithTransition,
    gotoErrors,
    gotoIndex,
    gotoSuccessInfoNoTransition,
};

export default gotoRoutes;